import { jwtDecode } from 'jwt-decode';
import { toast } from "sonner";

let checkInterval = null;

export async function verifyAuthToken(navigateTo) {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!token) {
            navigateTo('/login');
            return;
        }

        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
            localStorage.removeItem('authToken');
            toast.error('Login expirado, por favor faça-o novamente');
            navigateTo('/login');
            return;
        }

        if (!checkInterval) {
            checkInterval = setInterval(() => {
                verifyAuthToken(navigateTo);
            }, 10000);
        }

        return true;
    } catch (error) {
        localStorage.removeItem('authToken');
        navigateTo('/login');
        return;
    }
}